import React, { lazy, Suspense } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";
import Modal from "react-modal";

// styles
import "./App.scss";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import About from "./components/pages/About/About";
import LandingPage from "./components/pages/LandingPage";
import Protected from "./components/context/Protected";
import Calendar from "./components/pages/Calender/Calender"; // Regular import for Calendar

import RingLoader from "react-spinners/RingLoader";
import { motion } from "framer-motion";

// Lazy load components
const Pricing = lazy(() => import("./components/pages/Pricing"));
const Disclaimer = lazy(() => import("./components/pages/Disclaimer"));
const Aim = lazy(() => import("./components/pages/Aim"));

Modal.setAppElement("#root");

const LoadingSpinner = () => (
  <div className="loading">
    <h1 className="lod">Loading</h1>
    <RingLoader
      color="#36d7b7"
      size={80}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </div>
);

const App = () => {
  const { isLoading, error } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <motion.div initial="initial" animate="animate">
      <Router history={history}>
        <Header />
        <Suspense fallback={<LoadingSpinner />}>
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/schedule">
              <Protected>
                <Calendar />
              </Protected>
            </Route>

            <Route path="/about" component={About} />
            <Route path="/pricing" component={Pricing} />
            <Route path="/disclaimer" component={Disclaimer} />
            <Route path="/aov" component={Aim} />
          </Switch>
        </Suspense>
        <Footer />
      </Router>
    </motion.div>
  );
};

export default App;
